<template>
  <FormulateForm
    @input="performValidation"
    @submit="payNow"
    name="payform"
    ref="form"
  >
    <div class="bg-primary-500">
      <div class="pt-12">
        <div class="max-w-screen-xl mx-auto px-2 sm:px-6 lg:px-8">
          <div class="flex items-center justify-center">
            <div
              class="relative ml-4 w-24 lg:w-36 rounded-full border-white border-2 lg:border-4 overflow-hidden"
            >
              <div class="pb-full"></div>
              <a :href="`/${urlAlias}`">
                <img
                  v-if="avatar"
                  :src="`${avatar}`"
                  class="absolute left-0 top-0 w-full h-full object-cover"
                />
              </a>
            </div>
            <div class="pl-4 lg:pl-6">
              <h2
                class="text-3xl leading-tight font-light text-white sm:text-4xl sm:leading-10 lg:text-5xl lg:leading-none"
              >
                <a :href="`/${urlAlias}`" class="whitespace-nowrap">
                  {{ nickname }}
                </a>
              </h2>
              <div
                class="lg:mt-4 lg:text-xl leading-7 text-gray-50 font-extralight"
              >
                <div class="flex items-center justify-start">
                  <div class="relative w-7 h-7 mr-2">
                    <div
                      class="bg-white rounded-full m-1 w-5 h-5 absolute"
                    ></div>
                    <CheckIcon class="absolute w-auto h-7 text-black" />
                  </div>
                  <div class="hidden sm:block">
                    {{ $t('verified account') }}
                  </div>
                  <div class="sm:hidden">
                    {{ $t('verified account mobile') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-secondary-500 pb-16 sm:mt-4 sm:pb-20 lg:pb-28">
        <div class="relative">
          <div class="absolute inset-0 h-1/2 bg-primary-500"></div>
          <div
            class="relative max-w-screen-xl pt-9 lg:pt-9 mx-auto px-4 sm:px-6 lg:px-20"
          >
            <div
              class="max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex lg:flex-col"
            >
              <div class="lg:grid lg:grid-cols-2 lg:gap-12 bg-white lg:p-12">
                <div class="px-6 py-8 lg:p-0 lg:block">
                  <div
                    class="relative w-full rounded-lg overflow-hidden bg-secondary-100"
                  >
                    <div class="pb-full"></div>
                    <transition
                      enter-active-class="transition ease-out duration-400"
                      enter-class="opacity-0"
                      enter-to-class="opacity-100"
                      leave-active-class="transition ease-in duration-400"
                      leave-class="opacity-100"
                      leave-to-class="opacity-0"
                    >
                      <div
                        v-if="(zoomObject || {}).mediaType === 'video'"
                        class="absolute left-0 top-0 w-full h-full object-cover"
                      >
                        <video-player
                          class="w-full h-full"
                          :options="{
                            sources: zoomObject.sources,
                            poster: zoomObject.imgPath
                          }"
                        />
                      </div>

                      <img
                        v-else-if="
                          (zoomObject || {}).mediaType === 'image' ||
                          itemImageUrl
                        "
                        class="absolute left-0 top-0 w-full h-full object-cover"
                        :key="(zoomObject || {}).imgPath || itemImageUrl"
                        :src="(zoomObject || {}).imgPath || itemImageUrl"
                      />
                    </transition>
                  </div>

                  <div
                    v-if="itemMediaObjects.length"
                    class="grid grid-cols-3 gap-4 mt-4 lg:gap-6 lg:mt-6"
                  >
                    <button
                      class="relative w-full rounded-lg overflow-hidden bg-secondary-100 focus:outline-none focus:ring"
                      @click.prevent.stop="
                        zoomObject = {
                          imgPath: itemImageUrl,
                          mediaType: 'image'
                        }
                      "
                      @focus.prevent.stop="
                        zoomObject = {
                          imgPath: itemImageUrl,
                          mediaType: 'image'
                        }
                      "
                    >
                      <img
                        class="absolute left-0 top-0 w-full h-full object-cover"
                        :src="itemImageUrl"
                      />
                    </button>
                    <button
                      v-for="mediaObject of itemMediaObjects"
                      :key="mediaObject.imgPath"
                      class="relative w-full rounded-lg overflow-hidden bg-secondary-100 focus:outline-none focus:ring"
                      @click.prevent.stop="zoomObject = mediaObject"
                      @focus.prevent.stop="zoomObject = mediaObject"
                    >
                      <div
                        v-if="mediaObject.mediaType === 'video'"
                        class="play-button absolute z-10 w-full h-full flex items-center justify-center opacity-80 hover:opacity-100"
                      >
                        <span
                          class="px-5 py-3 rounded-lg px-3 py-1 border-2 border-red-500 duration-300 bg-red-500 text-red-100"
                        >
                          ▷
                        </span>
                      </div>
                      <div class="pb-full"></div>
                      <img
                        class="absolute left-0 top-0 w-full h-full object-cover"
                        :src="mediaObject.imgPath"
                      />
                    </button>
                  </div>

                  <div class="mt-8 hidden lg:block item-description">
                    <h2 class="text-primary-500 text-3xl">
                      {{ $t('Purchase Info') }}
                    </h2>
                    <div
                      class="mt-6 text-base leading-6 text-secondary-500"
                      v-html="item.description"
                    ></div>
                  </div>
                </div>
                <div class="lg:p-0">
                  <div
                    class="py-8 px-6 lg:p-12 bg-secondary-100 text-center lg:flex lg:flex-col lg:justify-center lg:rounded-lg"
                  >
                    <h3
                      class="text-2xl text-left leading-8 font-medium text-gray-900 sm:text-3xl sm:leading-9 pb-6"
                    >
                      {{ item.name }}
                    </h3>
                    <div
                      class="mt-4 flex items-center justify-center text-5xl leading-none font-extrabold text-gray-900"
                    >
                      <span v-if="!isCustom">
                        {{ $n(amount / 100, 'currency') }}
                      </span>
                      <span class="w-32" v-else>
                        <FormulateInput
                          type="number"
                          validation-name="Betrag"
                          error-behavior="live"
                          inputmode="numeric"
                          :validation="`number|min:${amount / 100}|max:2000`"
                          :show-value="true"
                          v-model="customAmount"
                          :min="amount / 100"
                        />
                      </span>
                      <span v-if="isCustom" class="font-normal text-lg pl-2">
                        ,- €
                      </span>
                      <span
                        v-if="isRecurring"
                        class="ml-3 text-xl leading-7 font-medium text-gray-500"
                      >
                        / {{ $t('month') }}
                      </span>
                      <span
                        v-else
                        class="ml-3 text-xl leading-7 font-medium text-gray-500"
                      >
                        / {{ $t('once') }}
                      </span>
                    </div>
                    <p class="mt-4 text-sm leading-5">
                      <span class="font-medium text-gray-500">
                        {{ $t('incl. 19% VAT') }}
                      </span>
                    </p>
                    <div
                      v-if="
                        item.afterSaleEnabled &&
                        item.afterSaleQuestion &&
                        !active &&
                        !requiredPurchases
                      "
                      class="mt-6 text-base leading-6 text-secondary-400 text-left"
                    >
                      <span
                        v-html="item.afterSaleQuestion.replace(':', '.')"
                      ></span>
                      <FormulateInput
                        class="text-secondary-500 mt-6"
                        type="textarea"
                        rows="3"
                        v-model="afterSaleAnswer"
                        error-behavior="live"
                        validation="required|max:500,length"
                        :validation-name="$t('This')"
                        :help="`Max 500 Zeichen. ${
                          500 - afterSaleAnswer.length
                        } übrig.`"
                      />
                    </div>
                    <div v-if="isLimited" class="mt-4">
                      <div
                        v-if="limitedAvailable"
                        class="text-green-500 font-bold pb-3"
                      >
                        <span v-if="item.showRemainingStock">
                          {{
                            $t('Limited stock', {
                              remaining: limitedAvailable
                            })
                          }}
                        </span>
                        <span v-else>
                          {{ $t('Limited stock available') }}
                        </span>
                      </div>
                      <div
                        v-if="!limitedAvailable"
                        class="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-gray-600 bg-gray-300"
                      >
                        {{ $t('Unfortunately sold out') }}
                      </div>
                    </div>
                    <div v-if="requiredPurchases" class="mt-6">
                      <p>{{ $t('Cannot purchase directly') }}</p>
                      <p v-if="requiredPurchases.length > 1">
                        {{ $t('You need one of the following items') }}
                      </p>
                      <p v-else>
                        {{ $t('You need the following item') }}
                      </p>
                      <p v-if="!isAuthenticated" class="mt-6">
                        {{ $t('You are not signed in') }}
                        {{ $t('Please') }}
                        <a
                          class="underline cursor-pointer text-primary-600 hover:text-primary-500"
                          :href="loginPath"
                        >
                          <span>{{ $t('sign in') }}</span>
                        </a>
                        <span>,</span>
                        {{ $t('if you already have an account') }}
                      </p>
                      <div
                        v-if="isAuthenticated && item.hasVouchers"
                        class="mt-8"
                      >
                        <voucher-input :rewardId="item._id" />
                      </div>
                      <div class="lg:mt-8">
                        <RequiredPurchases
                          :required-purchases="requiredPurchases"
                          :sidebar="true"
                        />
                      </div>
                    </div>

                    <div v-else-if="!isAuthenticated" class="mt-6">
                      <TransitionExpand>
                        <div v-if="!openRegister" class="rounded-md shadow">
                          <button
                            class="btn text-white bg-primary-600 hover:bg-primary-500 focus:outline-none focus:ring"
                            @click.prevent.stop="startRegister"
                          >
                            {{ $t('Pay now') }}
                          </button>
                        </div>
                      </TransitionExpand>
                      <TransitionExpand>
                        <RegisterForm
                          v-if="openRegister"
                          @registered="openRegister = false"
                          :redirectToCheckout="!isRecurring"
                          :rewardId="rewardId"
                          :grantWithdrawalRight="!!item.grantWithdrawalRight"
                          :customAmount="customAmount"
                          :afterSaleAnswer="afterSaleAnswer"
                        />
                      </TransitionExpand>
                    </div>

                    <div v-else-if="isAuthenticated" class="mt-6">
                      <div>
                        <span
                          v-if="active"
                          class="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-gray-600 bg-gray-300"
                        >
                          {{ $t('Active subscription') }}
                        </span>

                        <div v-else>
                          <div
                            v-if="isRecurring"
                            class="rounded-md shadow mt-6"
                          >
                            <goButton
                              :isLoading="isLoading"
                              :hasErrors="hasErrors || active"
                              btnType="button"
                              @btnclick="goCard"
                            >
                              <template #submit>
                                {{ $t('credit card') }}
                              </template>
                              <template #loading>
                                {{ $t('...loading') }}
                              </template>
                            </goButton>
                          </div>

                          <div v-if="!isRecurring">
                            <withdrawal-waiver
                              v-if="!isLimited || limitedAvailable"
                              :grantWithdrawalRight="
                                !!item.grantWithdrawalRight
                              "
                              @change="acceptedWaiver"
                              class="pb-5"
                            ></withdrawal-waiver>

                            <div v-if="!isLimited || limitedAvailable">
                              <div class="rounded-md shadow">
                                <submitButton
                                  :isLoading="isLoading"
                                  :hasErrors="hasErrors || active"
                                  :disabled="purchaseProhibited"
                                >
                                  <template #submit>
                                    <span>{{ $t('Go to checkout') }}</span>
                                  </template>
                                  <template #loading>
                                    {{ $t('...loading') }}
                                  </template>
                                </submitButton>
                              </div>

                              <div v-if="item.hasVouchers" class="mt-10">
                                <voucher-input :rewardId="item._id" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="isRecurring && !active" class="mt-6 mb-6">
                        <div class="relative">
                          <div class="absolute inset-0 flex items-center">
                            <div class="w-full border-t border-gray-300"></div>
                          </div>
                          <div
                            class="relative flex justify-center text-sm leading-5"
                          >
                            <span class="px-2 bg-secondary-100 text-gray-500">
                              {{ $t('or') }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="isRecurring && !active"
                        class="rounded-md shadow mt-6"
                      >
                        <goButton
                          :isLoading="isLoadingSepa"
                          :hasErrors="hasErrors || active"
                          btnType="button"
                          @btnclick="goSepa"
                        >
                          <template #submit>
                            {{ $t('S€PA direct debit') }}
                          </template>
                          <template #loading>
                            {{ $t('...loading') }}
                          </template>
                        </goButton>
                      </div>

                      <div v-if="isRecurring && !active" class="mt-6 mb-6">
                        <div class="relative">
                          <div class="absolute inset-0 flex items-center">
                            <div class="w-full border-t border-gray-300"></div>
                          </div>
                          <div
                            class="relative flex justify-center text-sm leading-5"
                          >
                            <span class="px-2 bg-secondary-100 text-gray-500">
                              {{ $t('or') }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="isRecurring && !active"
                        class="rounded-md shadow mt-6"
                      >
                        <amazon-pay-button
                          :isLoading="isLoadingAmazonpay"
                          :hasErrors="hasErrors || active"
                          @btnclick="goAmazonpay"
                        >
                          <template #loading>
                            {{ $t('...loading') }}
                          </template>
                        </amazon-pay-button>
                      </div>
                    </div>
                  </div>
                  <div class="hidden lg:block lg:mt-8">
                    <Unlockables
                      :unlocks="unlocks"
                      :name="item.name"
                      :sidebar="true"
                    />
                  </div>
                  <div class="hidden lg:block lg:mt-8">
                    <Recommendations :recommendations="recs" :sidebar="true" />
                  </div>
                </div>
              </div>
              <div
                class="lg:hidden"
                :class="{ 'lg:grid-cols-2': (recs || []).length }"
              >
                <div class="bg-white px-6 py-8 lg:p-12 item-description">
                  <h2 class="text-primary-500 text-3xl">
                    {{ $t('Purchase Info') }}
                  </h2>
                  <div
                    class="mt-6 text-base leading-6 text-secondary-500"
                    v-html="item.description"
                  ></div>
                </div>
                <div class="bg-white py-4">
                  <div class="px-6">
                    <Unlockables
                      :unlocks="unlocks"
                      :name="item.name"
                      :sidebar="true"
                    />
                  </div>
                </div>
                <div class="bg-white py-4">
                  <div class="px-6">
                    <Recommendations :recommendations="recs" />
                  </div>
                </div>
              </div>

              <GetnextInfos />
            </div>
          </div>
        </div>
      </div>
    </div>
  </FormulateForm>
</template>

<style scoped>
.btn {
  @apply w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md transition duration-150 ease-in-out;
}

.play-button:hover span,
.play-button span:hover {
  @apply bg-red-400 border-red-400;
}

.item-description >>> a {
  @apply text-primary-500 font-bold;
}

.item-description >>> a:hover {
  @apply text-black;
}

.item-description >>> ol {
  @apply list-decimal list-inside pl-6;
}

.item-description >>> ul {
  @apply list-disc list-inside pl-6;
}

/* Tiptap wraps each <li>'s content in a block <p>; with list-inside that
   pushes the text below the marker. Render it inline (Quill emitted bare
   <li> text, so list-inside used to just work). */
.item-description >>> li > p {
  @apply inline m-0;
}

.item-description >>> .ql-indent-1 {
  @apply pl-4;
}

.item-description >>> .ql-indent-2 {
  @apply pl-8;
}

.item-description >>> .ql-indent-3 {
  @apply pl-12;
}

.item-description >>> .ql-indent-4 {
  @apply pl-16;
}

.item-description >>> .ql-indent-5 {
  @apply pl-20;
}

.item-description >>> .ql-indent-6 {
  @apply pl-24;
}

.item-description >>> .ql-indent-7 {
  @apply pl-28;
}

.item-description >>> .ql-indent-8 {
  @apply pl-32;
}

.item-description >>> .ql-align-center {
  @apply text-center;
}

.item-description >>> .ql-align-right {
  @apply text-right;
}

.item-description >>> .ql-align-justify {
  @apply text-justify;
}

.item-description >>> .ql-align-left {
  @apply text-left;
}
</style>

<i18n>
en:
  Further details in the next step: You may provide further details in the next step
  Pay now: Pay now
  incl. 19% VAT: incl. 19% VAT
  once: once
  month: month
  Pay once: Pay once
  Pay per month, cancel anytime: Pay per month, cancel anytime
  Active subscription: Active subscription
  Active subscription, cancel anytime: Active subscription, cancel anytime
  ...loading: ...loading
  S€PA direct debit: S€PA direct debit
  or: or
  credit card: credit card
  What's included: What's included
  Please LogIn or Register: Please LogIn or Register
  verified account: Official artist account
  verified account mobile: Official artist account
  This: This
  Purchase Info: Purchase Information
  Cannot purchase directly: This item cannot be purchased directly.
  You need the following item: You need the following item to unlock this offer.
  You need one of the following items: You need one of the following items before you can unlock this offer.
  You are not signed in: You are not signed in.
  Please: Please
  sign in: sign in
  if you already have an account: if you already have an account.
  Limited stock: Only {remaining} remaining
  Limited stock available: Limited stock available
  Unfortunately sold out: Unfortunately sold out
  Go to checkout: Go to checkout

de:
  Further details in the next step: Weitere Angaben im nächsten Schritt
  Pay now: Jetzt kaufen
  incl. 19% VAT: inkl. 19% MwSt
  once: einmalig
  month: Monat
  Pay once: Zahle einmalig
  Pay per month, cancel anytime: Zahle monatlich, jederzeit kündbar
  Active subscription: Aktives Abo
  Active subscription, cancel anytime: Aktives Abo, jederzeit kündbar
  ...loading: ...laden
  S€PA direct debit: S€PA Lastschrift
  or: oder
  credit card: Kreditkarte
  What's included: Beinhaltet
  Please LogIn or Register: Anmelden / Registrieren
  verified account: Verifizierter Account
  verified account mobile: Verifizierter Account
  This: Das
  Purchase Info: Infos zum Kauf
  Cannot purchase directly: Dieser Artikel kann nicht direkt gekauft werden.
  You need the following item: Du benötigst den nachfolgenden Artikel, um dieses Angebot freizuschalten.
  You need one of the following items: Du benötigst zuvor einen der nachfolgenden Artikel, um dieses Angebot freizuschalten.
  You are not signed in: Du bist nicht eingeloggt.
  Please: Bitte
  sign in: logge Dich ein
  if you already have an account: falls Du bereits ein Konto hast.
  Limited stock: Noch {remaining} verfügbar
  Limited stock available: Begrenzte Anzahl verfügbar
  Unfortunately sold out: leider ausverkauft
  Go to checkout: Zur Kasse

</i18n>

<script>
/* global Stripe */

import dottie from 'dottie'
import striptags from 'striptags'
import { store } from '@/store'
import { sync, call } from 'vuex-pathify'

import submitButton from '@/components/submitButton.vue'
import goButton from '@/components/goButton.vue'
import AmazonPayButton from '@/components/amazonPayButton.vue'
import RegisterForm from '@/components/registerForm.vue'

import TransitionExpand from '@/components/transitions/TransitionExpand.vue'

import Recommendations from '@/components/recommendations.vue'
import Unlockables from '@/components/unlockables.vue'
import RequiredPurchases from '@/components/requiredPurchases.vue'
import GetnextInfos from '@/components/getnextInfos.vue'
import CheckIcon from '@/components/icons/check.vue'

import videoPlayer from '@/components/videoPlayer.vue'

import WithdrawalWaiver from '@/components/withdrawalWaiver.vue'
import VoucherInput from '@/components/voucherInput.vue'

const fetchData = async (to, from, next) => {
  await store.dispatch('user/read')
  const buyerId = store.get('user/userId')
  const { rewardId } = to.params

  await store.dispatch('reward/read', { rewardId, buyerId })
  await store.dispatch('checkout/readKey', { rewardId })
  const rewardReadOK = store.get('reward/readOK')
  const checkoutReadOK = store.get('checkout/readOK')

  setTimeout(() => {
    window.prerenderReady = true
  }, 500)

  if (!rewardReadOK || !checkoutReadOK) {
    return next({ name: 'NotFound' })
  }
  next()
}

export default {
  beforeRouteEnter: fetchData,
  beforeRouteUpdate: fetchData,

  components: {
    submitButton,
    goButton,
    AmazonPayButton,
    RegisterForm,
    TransitionExpand,
    Recommendations,
    Unlockables,
    RequiredPurchases,
    GetnextInfos,
    CheckIcon,
    videoPlayer,
    WithdrawalWaiver,
    VoucherInput
  },

  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        { name: 'title', content: this.metaTitle },
        { name: 'description', content: this.metaDescription },

        // Open Graph / Facebook
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: this.metaUrl },
        { property: 'og:title', content: this.metaTitle },
        { property: 'og:description', content: this.metaDescription },
        { property: 'og:image', content: this.metaImage },

        // Twitter
        { property: 'twitter:card', content: 'summary_large_image' },
        { property: 'twitter:url', content: this.metaUrl },
        { property: 'twitter:title', content: this.metaTitle },
        { property: 'twitter:description', content: this.metaDescription },
        { property: 'twitter:image', content: this.metaImage }
      ]
    }
  },

  data() {
    return {
      $stripe: null,
      sessionId: null,
      openRegister: false,
      hasErrors: false,
      isLoading: false,
      isLoadingSepa: false,
      isLoadingAmazonpay: false,
      customAmount: null,
      afterSaleAnswer: '',
      zoomObject: null,
      player: null,
      waiverAccepted: false
    }
  },

  computed: {
    user: sync('user'),
    isAuthenticated: sync('user/isAuthenticated'),
    buyerId: sync('user/userId'),
    buyerName: sync('user/nickname'),
    purchases: sync('user/purchases'),
    sellerId: sync('reward/userId'),
    nickname: sync('reward/nickname'),
    urlAlias: sync('reward/urlAlias'),
    profile: sync('reward/profile'),
    reward: sync('reward/reward'),
    product: sync('reward/product'),
    rewards: sync('reward/rewards'),
    products: sync('reward/products'),
    active: sync('reward/active'),
    publishableKey: sync('checkout/publishableKey'),
    accId: sync('checkout/accId'),
    checkoutData: sync('checkout/checkoutData'),
    recs: sync('reward/recommendations'),
    unlocks: sync('reward/unlockables'),

    metaTitle() {
      return striptags(this.item.name)
    },

    metaDescription() {
      return striptags(this.item.description)
    },

    metaUrl() {
      return window.location.href
    },

    metaImage() {
      return `https://${window.location.hostname}${this.itemImageUrl}`
    },

    item() {
      return this.reward || this.product
    },

    itemImageUrl() {
      const imgName = dottie.get(this.item, 'image.name', null)
      if (imgName) {
        return `/services/media/image/${this.sellerId}/${imgName}/488/0/image.jpeg`
      } else {
        return ''
      }
    },

    itemMediaObjects() {
      const media = dottie.get(this.item, 'media', [])

      if (media.length) {
        return media
          .map((m) => {
            if (this.isImage(m)) {
              if (m.name) {
                return {
                  imgPath: `/services/media/image/${this.sellerId}/${m.name}/488/0/image.jpeg`,
                  mediaType: 'image'
                }
              }
            } else if (this.isVideo(m)) {
              if (!m.sources || !m.sources.length) {
                return { available: false }
              }
              return {
                name: m.name,
                sources: m.sources,
                imgPath: `/uploads/public/${this.sellerId}/${m.name}/screenshot_2.jpg`,
                mediaType: 'video'
              }
            }
            return null
          })
          .filter((m) => m.available !== false)
      }
      return []
    },

    isLimited() {
      return dottie.get(this.item, 'stockLimit', false)
    },

    limitedAvailable() {
      const limit = dottie.get(this.item, 'stockLimit', 0)
      const ordered = dottie.get(this.item, 'stockOrdered', 0)
      const available = limit - ordered
      return available > 0 && available
    },

    amount() {
      if (this.item.minAmount && Number(this.item.minAmount) > 0) {
        return Number(this.item.minAmount)
      } else {
        return Number(this.item.amount) || 0
      }
    },
    isCustom() {
      return this.item.minAmount && Number(this.item.minAmount) > 0
    },
    isRecurring() {
      return dottie.get(this.item, 'payment.recurring', false)
    },
    avatar() {
      return dottie.get(this.profile, 'imgs.avatar.previewUrl', null)
    },
    rewardId() {
      return this.item._id
    },
    isDependingOn() {
      return this.item.dependingOn && this.item.dependingOn.length
    },
    requiredPurchases() {
      if (!this.isDependingOn) return false
      if (
        this.purchases &&
        [...this.purchases.pledges, ...this.purchases.sales].some((i) =>
          this.item.dependingOn.includes(i)
        )
      )
        return false

      return [...this.products, ...this.rewards].filter((i) =>
        this.item.dependingOn.includes(i._id)
      )
    },

    deepLink() {
      return this.product
        ? `/${this.urlAlias}/single-rewards/#product_${this.rewardId}`
        : `/${this.urlAlias}/rewards/#reward_${this.rewardId}`
    },
    purchaseProhibited() {
      return !this.item.grantWithdrawalRight && !this.waiverAccepted
    },
    loginPath() {
      const path = window.location.pathname
      return this.$i18n.locale === 'en'
        ? `/portal/login?redirect=${path}`
        : `/portal/einloggen?redirect=${path}`
    }
  },

  mounted() {
    this.customAmount = this.amount / 100
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout')
    }
  },

  methods: {
    gotoLogin: call('user/gotoLogin'),
    startSession: call('checkout/startSession'),
    startAmazonpay: call('amazonpay/start'),
    persistCheckoutData: call('amazonpay/persistCheckoutData'),

    async startRegister() {
      this.hasErrors = await this.$refs.form.hasValidationErrors()
      if (!this.hasErrors) {
        this.openRegister = true
      }
    },

    async performValidation() {
      if (this.$refs.form) {
        this.hasErrors = await this.$refs.form.hasValidationErrors()
      }
    },

    async goSepa(e) {
      e.preventDefault()
      if (this.hasErrors) return
      await this.$refs.form.showErrors()

      if (!(await this.$refs.form.hasValidationErrors())) {
        this.isLoadingSepa = true
        this.checkoutData = {
          itemId: this.rewardId,
          buyerId: this.buyerId,
          customAmount: this.customAmount,
          afterSaleAnswer: this.afterSaleAnswer
        }
        this.$router.push({
          name: 'sepa',
          params: { rewardId: this.rewardId, buyerId: this.buyerId }
        })
      }
    },

    async goCard(e) {
      e.preventDefault()
      if (this.hasErrors) return
      await this.$refs.form.showErrors()

      if (!(await this.$refs.form.hasValidationErrors())) {
        this.isLoading = true
        this.checkoutData = {
          itemId: this.rewardId,
          buyerId: this.buyerId,
          customAmount: this.customAmount,
          afterSaleAnswer: this.afterSaleAnswer
        }
        this.$router.push({
          name: 'card',
          params: { rewardId: this.rewardId, buyerId: this.buyerId }
        })
      }
    },

    async goAmazonpay(e) {
      e.preventDefault()
      if (this.hasErrors) return
      await this.$refs.form.showErrors()

      if (!(await this.$refs.form.hasValidationErrors())) {
        this.isLoadingAmazonpay = true

        const checkoutData = {
          itemId: this.rewardId,
          buyerId: this.buyerId,
          customAmount: this.customAmount,
          afterSaleAnswer: this.afterSaleAnswer
        }

        const clientSecret = await this.startAmazonpay(checkoutData)

        if (!clientSecret) {
          this.isLoadingAmazonpay = false
          return
        }

        /**
         * checkout data has to survive the redirect to Amazon
         */
        await this.persistCheckoutData({
          ...checkoutData,
          sellerId: this.sellerId
        })

        if (!this.$stripe) {
          this.$stripe = Stripe(this.publishableKey)
        }

        const { error } = await this.$stripe.confirmAmazonPaySetup(
          clientSecret,
          {
            return_url: `${window.location.origin}/checkout/amazonpay/return/${this.rewardId}/${this.buyerId}`,
            mandate_data: {
              customer_acceptance: {
                type: 'online',
                online: { infer_from_client: true }
              }
            }
          }
        )

        if (error) {
          console.error(error.message)
        }

        this.isLoadingAmazonpay = false
      }
    },

    async payNow() {
      if (this.hasErrors) return

      this.isLoading = true

      if (!this.$stripe) {
        this.$stripe = Stripe(this.publishableKey)
      }

      const session = await this.startSession({
        itemId: this.rewardId,
        buyerId: this.buyerId,
        customAmount: this.customAmount,
        afterSaleAnswer: this.afterSaleAnswer
      })

      if (session && session.sessionId) {
        await this.$stripe.redirectToCheckout(session)
      }

      if (session && session.code === 666) {
        this.$router.push({
          name: 'soldOut',
          params: { rewardId: this.rewardId, sellerId: this.sellerId }
        })
      }

      this.isLoading = false
    },

    isImage(m) {
      return m.fileType.match(/^image\/(jpeg|jpg|gif|png)$/)
    },

    isVideo(m) {
      return (
        m.fileType.match('video/*') || m.fileType.match('application/x-mpegurl')
      )
    },
    acceptedWaiver(val) {
      this.waiverAccepted = val
    },

    login() {
      this.gotoLogin({ locale: this.$i18n.locale })
    }
  }
}
</script>
